var classof   = require('./$.classof')
  , ITERATOR  = require('./$.wks')('iterator')
  , Iterators = require('./$.iterators');
module.exports = require('./$.core').isIterable = function(it){
  var O = Object(it);
  return O[ITERATOR] !== undefined
    || '@@iterator' in O
    || Iterators.hasOwnProperty(classof(O));
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/core-js/library/modules/core.is-iterable.js
 ** module id = 331
 ** module chunks = 1
 **/